<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";

export default {
  name: "PopinPanierActualise",
  components: { Popin, Icon, Badge },
  methods: {
    show() {
      this.$refs.popin.show();
    }
  }
};
</script>

<template>
  <Popin
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    size="sm"
    ref="popin"
    auto-hide
    aria-label="Panier actualisé"
    :show-close-button="false"
    class="u-text-center"
  >
    <div class="c-popin-panier-actualise__status">
      <Icon
        name="refresh"
        size="xlg"
      />
      <Badge
        size="sm"
        variant="success"
        circle
        class="c-popin-panier-actualise__status-check"
      >
        <Icon
          name="check"
          size="xlg"
          variant="white"
        />
      </Badge>
    </div>
    <p class="u-mb-lg u-mt-sm">
      Votre panier a été actualisé
    </p>
  </Popin>
</template>

<style lang="scss" scoped>
.c-popin-panier-actualise__status {
  position: relative;
  display: inline-block;
}
.c-popin-panier-actualise__status-check {
  position: absolute;
  bottom: 6px;
  right: 2px;
}
</style>
